import liff from '@line/liff';

interface LiffClient {
  init: (config: { liffId: string }) => Promise<void>;
  isInClient: () => boolean;
  isLoggedIn: () => boolean;
  login: (config?: { redirectUri?: string }) => void;
  getProfile: () => Promise<{
    userId: string;
    displayName: string;
    pictureUrl?: string;
    statusMessage?: string;
  }>;
}

export type LiffProfile = Awaited<ReturnType<LiffClient['getProfile']>>;

export const isLiffInClient = (): boolean => {
  const liffClient = liff as unknown as LiffClient;

  try {
    return liffClient.isInClient();
  } catch (error) {
    console.warn('LIFF isInClient check failed:', error);
    return false;
  }
};

export const initLiffFromBrand = async (liffId: string): Promise<void> => {
  const liffClient = liff as unknown as LiffClient;

  try {
    await liffClient.init({ liffId });
    // alert(window.location.href);
    // alert('isLoggedIn = ' + liffClient.isLoggedIn());

    if (!liffClient.isLoggedIn()) {
      // liffClient.login({ redirectUri: redirectUri ?? window.location.href });
      liffClient.login();
    }
  } catch (error) {
    // Standalone web must continue working even if LIFF init fails.
    console.error('LIFF id = ' + liffId + ' init failed:', error);
  }
};

export const getLiffProfile = async (): Promise<LiffProfile | null> => {
  const liffClient = liff as unknown as LiffClient;

  try {
    if (!liffClient.isLoggedIn()) return null;
    return await liffClient.getProfile();
  } catch (error) {
    console.warn('LIFF getProfile failed:', error);
    return null;
  }
};
